export enum EmailTemplateEnum {
    Name = "name",
    EmailSubject = "emailSubject",
    EmailBody = "emailBody",
    Attachments = "attachments",
    FirstNameUpdated = "firstNameUpdated",
    LastNameUpdated = "lastNameUpdated",
    EmailUpdated = "emailUpdated"
}
